import * as Yup from "yup";

export const veiculoValidator = Yup.object().shape({
  veiculoProprio: Yup.boolean(),
  intPessoaId: Yup.mixed().when("veiculoProprio", {
    is: false,
    then: Yup.string().typeError("Proprietário").required("Proprietário"),
    otherwise: Yup.string().nullable(),
  }),
  placa: Yup.string().required("Placa"),
  ufLicenciamento: Yup.string().required("UF Licenciamento"),
  renavam: Yup.string().nullable(),
  tipo: Yup.string().required("Tipo"),
  tipoRodado: Yup.mixed().when("tipo", {
    is: "VEICULO",
    then: Yup.string().typeError("Tipo de Rodado").required("Tipo de Rodado"),
    otherwise: Yup.string().nullable(),
  }),
  tipoCarroceria: Yup.string().required("Tipo de Carroceria"),
  tara: Yup.number().required("Tara"),
  capacidadeKg: Yup.number().required("Capacidade em (Kg)"),
  capacidadeM3: Yup.number().required("Capacidade em (m3)"),
  rntcProprietario: Yup.number().nullable(),
});
